module.exports = __webpack_public_path__ + "static/media/base_1.c1902398.png";